import React from "react";
import { Button, DropdownButton, Dropdown, Form, Tabs, Tab, Modal, ToggleButton } from 'react-bootstrap';
import { Nav, ListGroup } from 'react-bootstrap';
import { context } from '../../AppContext';
import Flow from "../../flow/Flow";

export default class ConfigRaw extends React.Component {

    state = {
        saving: false
    };
    configTextAreaRef = React.createRef();

    render() {
        return (
            <div className="ConfigRaw">
                { this.props.extraButtons ?
                (
                    <div
                        style={{ display: 'inline-block', marginRight: 20 }}
                    >
                        { this.props.extraButtons}
                    </div>
                ) : null }
                <Button
                    style={{ marginRight: 25 }}
                    onClick={ async () => {
                        this.props.detailScreen.showConfigHistory(this.props.fileName);
                    }}
                >History</Button>
                <Button
                    style={{ float: 'right' }}
                    disabled={ this.state.saving }
                    onClick={ async () => {
                        if (this.props.onSave) {
                            return this.props.onSave();
                        }
                        try {
                            let parsedConfig = JSON.parse(this.props.textAreaRef?.current.value || this.configTextAreaRef.current.value);
                            this.setState({ saving: true});
                            let res = await context.makeRequest("Site.setConfig", {
                                siteId: this.props.detailScreen.state.itemData.id,
                                fileName: this.props.fileName,
                                data: parsedConfig
                            });
                            if (res.error)
                                alert("Error:" + res.error.message);
                            else
                                alert("Success");
                        } catch (err) {
                            alert("Error parsing JSON");
                        } finally {
                            this.setState({ saving: false});
                        }
                    }}
                >Save</Button>
                <textarea 
                    style={{ width: '100%', height: '700px' }} 
                    defaultValue={ this.props.data } 
                    ref={ this.props.textAreaRef || this.configTextAreaRef }
                />
            </div>
        );
    }
}